import ReactGA from 'react-ga4'

const ANALYTICS_ENABLED = Boolean(process.env.REACT_APP_GOOGLE_ANALYTICS_ID)

const initializeAnalytics = () => {
  const ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID

  if (!ID) return // skip analytics when unconfigured (e.g. local dev)

  ReactGA.initialize(ID, {
    gtagOptions: {
      send_page_view: false
    }
  }) // GA4 Measurement ID
}

const trackPageView = (page, title) => {
  if (!ANALYTICS_ENABLED) return

  ReactGA.send({
    hitType: 'pageview',
    page,
    title
  })
}

const trackEvent = ({ category, action, label }) => {
  if (!ANALYTICS_ENABLED) return

  ReactGA.event({
    category,
    action,
    label
  })
}

export {
  initializeAnalytics,
  trackPageView,
  trackEvent
}
